import { render } from "./GoogleReviews.vue?vue&type=template&id=697541b0"
import script from "./GoogleReviews.vue?vue&type=script&lang=js"
export * from "./GoogleReviews.vue?vue&type=script&lang=js"

import "./GoogleReviews.vue?vue&type=style&index=0&id=697541b0&lang=css"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__